const users = [
  {
    id: 1,
    user_name: "test",
    email: "test@gmail.com",
    user_phone: 1234567890,
    password: 123,
    profession: "Real Estate Agent",
    location: "Chennai, Tamil Nadu",
    profile: "https://randomuser.me/api/portraits/men/32.jpg" ,
    refersh_token:"demooooooooooooooooooooooooooo",
    access_token:"testtttttttttttttttttttttttttttttttttttt",
    recent_property_id:[1,2,3],
    wishlist: [5, 1, 7],

    
    social: [
      {
        id: 1,
        social_id: 1,
        name: "Instagram",
        icon: "FaInstagram",
        link: "https://www.instagram.com/test/",
        is_show: true,
      },
      {
        id: 2,
        social_id: 2,
        name: "Facebook",
        icon: "FaFacebookF",
        link: "https://www.facebook.com/test/",
        is_show: true,
      },
      {
        id: 3,
        social_id: 3,
        name: "LinkedIn",
        icon: "FaLinkedinIn",
        link: "https://www.linkedin.com/in/test/",
        is_show: true,
      },
      {
        id: 4,
        social_id: 4,
        name: "Twitter",
        icon: "FaXTwitter",
        link: "https://www.twitter.com/test/",
        is_show: false,
      },
      {
        id: 5,
        social_id: 5,
        name: "YouTube",
        icon: "FaYoutube",
        link: "https://www.youtube.com/@test/",
        is_show: false,
      },
      {
        id: 6,
        social_id: 6,
        name: "WhatsApp",
        icon: "FaWhatsapp",
        link: "https://wa.me/911234567890",
        is_show: true,
      },
    ],
  },
  {
    id: 2,
    user_name: "test",
    email: "test@pif.com",
    user_phone: 9876543210,
    password: 123,
    profession: "Real Estate Agent",
    location: "Chennai, Tamil Nadu",
    profile: "https://randomuser.me/api/portraits/men/32.jpg" ,
    refersh_token:"demooooooooooooooooooooooooooo1",
    access_token:"testtttttttttttttttttttttttttttttttttttt1",
    recent_property_id:[4,5,6],
    wishlist: [5, 1, 7],
    
    social: [
      {
        id: 1,
        social_id: 1,
        name: "Instagram",
        icon: "FaInstagram",
        link: "https://www.instagram.com/test/",
        is_show: true,
      },
      {
        id: 2,
        social_id: 2,
        name: "Facebook",
        icon: "FaFacebookF",
        link: "https://www.facebook.com/test/",
        is_show: true,
      },
      {
        id: 3,
        social_id: 3,
        name: "LinkedIn",
        icon: "FaLinkedinIn",
        link: "https://www.linkedin.com/in/test/",
        is_show: true,
      },
      {
        id: 4,
        social_id: 4,
        name: "Twitter",
        icon: "FaXTwitter",
        link: "https://www.twitter.com/test/",
        is_show: false,
      },
      {
        id: 5,
        social_id: 5,
        name: "YouTube",
        icon: "FaYoutube",
        link: "https://www.youtube.com/@test/",
        is_show: false,
      },
      {
        id: 6,
        social_id: 6,
        name: "WhatsApp",
        icon: "FaWhatsapp",
        link: "https://wa.me/911234567890",
        is_show: true,
      },
    ],
  },
];

export default users;